module.exports = __webpack_public_path__ + "img/lr.38ffd8a3.webp";